import { Form, Select } from 'antd';
import { useState } from 'react';

import useProductStore from '@/features/Product/store/ProductStore';

import { SCRAPER_REQ_FIELD_KEY } from '../../configs/scraper-field-map/field-const';

export const ProductLineField = (props: { required?: boolean }) => {
  const { required = false } = props;
  const lineMap = useProductStore((state) => state.lineMap);
  const [tempProductLineOptions, setTempProductLineOptions] = useState<
    string[]
  >(Array.from(lineMap.values()).map((line) => line.name));

  return (
    <>
      {/* Hidden Form.Item for actual value storage */}
      <Form.Item
        name={SCRAPER_REQ_FIELD_KEY.PRODUCT_LINE}
        required={required}
        rules={
          required
            ? [{ required: true, message: 'Product line is required' }]
            : []
        }
        hidden
      >
        <input />
      </Form.Item>

      {/* Display Form.Item with render function */}
      <Form.Item label="Product line" shouldUpdate required={required}>
        {({ getFieldValue, setFieldValue }) => {
          const currentProductLine: string = getFieldValue(
            SCRAPER_REQ_FIELD_KEY.PRODUCT_LINE,
          );
          return (
            <Select
              value={currentProductLine ? [currentProductLine] : []}
              options={tempProductLineOptions.map((value) => ({
                label: value,
                value,
              }))}
              placeholder="Select product line"
              mode="tags"
              maxTagCount={1}
              onSelect={(value) => {
                setFieldValue(SCRAPER_REQ_FIELD_KEY.PRODUCT_LINE, value);
                if (value && !tempProductLineOptions.includes(value)) {
                  setTempProductLineOptions((prev) => [...prev, value]);
                }
              }}
              onDeselect={() => {
                setFieldValue(SCRAPER_REQ_FIELD_KEY.PRODUCT_LINE, '');
              }}
            />
          );
        }}
      </Form.Item>
    </>
  );
};
